import { ConfirmationType } from 'shared/types';

export const SURVEYS_PER_PAGE = 10;

type ConfirmationState = 'pause' | 'activate' | 'delete' | 'close';

export const ConfirmationPopup: Record<ConfirmationState, ConfirmationType> = {
  pause: {
    id: new Date().toISOString(),
    title: 'Confirm pause',
    confirmButtonText: 'Confirm',
    description: `Are you sure you'd like to pause this survey?`,
    glyph: 'info',
    // infoText:
    //   'Pausing this survey will pause all active response collectors as well',
    className: 'info',
  },
  activate: {
    id: new Date().toISOString(),
    title: 'Confirm activation',
    confirmButtonText: 'Confirm',
    description: `Are you sure you'd like to activate this survey?`,
    glyph: 'info',
    // infoText:
    //   'Activating this survey will also activate any paused response collectors',
    className: 'info',
  },
  delete: {
    id: new Date().toISOString(),
    title: 'Confirm delete',
    confirmButtonText: 'Confirm',
    description: `Are you sure you'd like to delete this survey?`,
    glyph: 'info',
    infoText: 'All Responses associated with this survey will also be deleted.',
    className: 'info',
  },
  close: {
    id: new Date().toISOString(),
    title: 'Confirm close survey',
    confirmButtonText: 'Confirm',
    description: `Are you sure to close this survey?`,
    glyph: 'info',
    infoText: 'Closing the survey will stop collecting the responses',
    className: 'info',
  },
};

type ToasterMsgType = {
  success: string;
  error: string;
};

type ToasterState = 'pause' | 'activate' | 'delete' | 'complete';

export const ToasterMessage: Record<ToasterState, ToasterMsgType> = {
  pause: {
    success: 'Survey paused successfully',
    error: 'Failed to pause survey',
  },
  activate: {
    success: 'Survey activated successfully',
    error: 'Failed to activate survey',
  },
  delete: {
    success: 'Survey deleted successfully',
    error: 'Failed to delete survey',
  },
  complete: {
    success: 'Survey closed successfully',
    error: 'Failed to close survey',
  },
};
